export const REQUESTED_PROPERTY_DECLINE_REASON = Object.freeze({
    DeclinedByGuest: 1,
    DeclinedByManager: 2,
    DeclinedBySUpplier: 3
})